import xhr from 'Common/utils/xhr'

async function signUp(data) {
  try {
    const response = await xhr({
      url: '/sign_up.json',
      method: 'POST',
      data,
    })

    return { redirectTo: response.headers.location }
  } catch (e) {
    const error = new Error()
    error.fieldErrors = e.response?.data?.errors || {}

    throw error
  }
}

export default signUp
